var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('terminal',{ref:_vm.name,attrs:{"name":_vm.name,"title":_vm.title,"context":_vm.context,"commandStore":_vm.cmdStore,"init-log":_vm.initLog},on:{"execCmd":_vm.onExecCmd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }